import { render, staticRenderFns } from "./CertificateFormGlobal.vue?vue&type=template&id=cb08d722&"
import script from "./CertificateFormGlobal.vue?vue&type=script&lang=js&"
export * from "./CertificateFormGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports